import React from 'react';
import './index.css'
/*<--plop-react-provider-imports-->*/
import { ResponsiveProvider } from './contexts/ResponsiveContext/ResponsiveContext'
import { KeyholeListingProvider } from './contexts/KeyholeListingContext/KeyholeListingContext';
import KeyholeThemeProvider from '@bit/jimmijoensson.keyhole.components.keyhole-theme-provider'
import KeyholeListings from './components/KeyholeListings';
import UiWrapper from './components/UiWrapper';

if (process.env.REACT_APP_ENV === 'dev') {
  require('./utils/fonts.css')
}

export default function App() {

  return (
    <KeyholeThemeProvider>
      {/*<--plop-react-provider-start-->*/}
      <ResponsiveProvider>
        <KeyholeListingProvider>
          <UiWrapper>
            <KeyholeListings />
          </UiWrapper>
          {/*<--plop-react-provider-end-->*/}
        </KeyholeListingProvider>
      </ResponsiveProvider>
    </KeyholeThemeProvider>
  )
}
